import { Button } from '@mui/material';

interface ICreativesModalButtonsProps {
  handleClose: () => void;
  handleSave?: () => void;
  loading?: boolean;
  saveButtonTitle: string;
  saveButtonLoadingTitle?: string;
  isSaveDisabled?: boolean;
}

const CreativesModalButtons = ({
  handleClose,
  handleSave,
  loading,
  saveButtonTitle,
  saveButtonLoadingTitle,
  isSaveDisabled = false,
}: ICreativesModalButtonsProps) => (
  <div className='mt-7 flex justify-end space-x-3'>
    <Button
      variant='outlined'
      color='inherit'
      onClick={handleClose}
      sx={{
        height: '48px',
        width: '130px',
      }}
    >
      <span>Close</span>
    </Button>
    <Button
      loading={loading}
      loadingPosition='end'
      type={handleSave ? 'button' : 'submit'}
      variant='contained'
      sx={{
        height: '48px',
        width: '200px',
      }}
      disabled={isSaveDisabled}
      onClick={handleSave}
    >
      {loading ? saveButtonLoadingTitle : saveButtonTitle}
    </Button>
  </div>
);

export default CreativesModalButtons;
